<div class="flex flex-col items-center justify-center min-h-screen p-4 bg-gray-50">
  <p-toast></p-toast>

  <p-card class="w-full max-w-5xl shadow-4 rounded-2xl bg-white">
    <!-- Header -->
    <ng-template pTemplate="header">
      <div class="flex justify-between items-center p-5">
        <div>
          <h2 class="text-2xl font-semibold">Profilo Utente</h2>
          <p class="text-sm text-gray-500">Gestisci le tue informazioni</p>
        </div>

        <div class="flex gap-2">
          <p-button
            *ngIf="!editMode"
            icon="pi pi-pencil"
            [rounded]="true"
            [outlined]="true"
            (onClick)="toggleEditMode()"
            pTooltip="Modifica"
          />
          <p-button
            *ngIf="editMode"
            icon="pi pi-times"
            [rounded]="true"
            [outlined]="true"
            severity="danger"
            (onClick)="toggleEditMode()"
            pTooltip="Annulla"
          />
          <p-button
            *ngIf="editMode"
            icon="pi pi-check"
            [rounded]="true"
            [outlined]="true"
            severity="success"
            [loading]="saving"
            (onClick)="saveProfile()"
            pTooltip="Salva"
          />
        </div>
      </div>
    </ng-template>

    <form [formGroup]="profileForm" class="grid grid-cols-1 md:grid-cols-2 gap-6 p-4">

      <!-- Avatar -->
      <div class="col-span-1 md:col-span-2 flex flex-col items-center text-center mb-4">
        <input type="file" #fileInput accept="image/*" hidden (change)="onFileSelected($event)" />

        <p-avatar
          *ngIf="user?.imageMediaUrl; else defaultAvatar"
          [image]="user!.imageMediaUrl!"
          class="relative kc-avatar-logo"
          shape="circle"
        >
          <p-button
            icon="pi pi-image"
            [rounded]="true"
            severity="secondary"
            class="absolute kc-avatar-upload-button"
            (click)="fileInput.click()"
          />
        </p-avatar>

        <ng-template #defaultAvatar>
          <p-avatar icon="pi pi-user" size="xlarge" class="relative kc-avatar-logo" shape="circle">
            <p-button
              icon="pi pi-image"
              [rounded]="true"
              severity="secondary"
              class="absolute kc-avatar-upload-button"
              (click)="fileInput.click()"
            />
          </p-avatar>
        </ng-template>

        <h3 class="text-xl font-medium mt-2">{{ user?.username || 'User' }}</h3>
        <p class="text-sm text-gray-500">{{ user?.email || 'No email available' }}</p>
        <p-divider class="my-4 w-full"></p-divider>
      </div>

      <!-- First name -->
      <div>
        <label for="firstName" class="block text-sm font-medium text-gray-600 mb-1">Nome</label>
        <input id="firstName" pInputText formControlName="firstName" [readonly]="!editMode" class="w-full" />
      </div>

      <!-- Last name -->
      <div>
        <label for="lastName" class="block text-sm font-medium text-gray-600 mb-1">Cognome</label>
        <input id="lastName" pInputText formControlName="lastName" [readonly]="!editMode" class="w-full" />
      </div>

      <!-- Username -->
      <div>
        <label for="username" class="block text-sm font-medium text-gray-600 mb-1">Username</label>
        <input id="username" pInputText formControlName="username" [readonly]="!editMode" class="w-full" />
        <small *ngIf="profileForm.get('username')?.invalid && profileForm.get('username')?.touched" class="p-error">
          Username è obbligatorio
        </small>
      </div>

      <!-- Email -->
      <div>
        <label for="email" class="block text-sm font-medium text-gray-600 mb-1">Email</label>
        <input id="email" type="email" pInputText formControlName="email" [readonly]="!editMode" class="w-full" />
        <small *ngIf="profileForm.get('email')?.invalid && profileForm.get('email')?.touched" class="p-error">
          <span *ngIf="profileForm.get('email')?.errors?.['required']">Email è obbligatoria</span>
          <span *ngIf="profileForm.get('email')?.errors?.['email']">Email non valida</span>
        </small>
      </div>

      <!-- Role -->
      <div>
        <label class="block text-sm font-medium text-gray-600 mb-1">Ruolo</label>
        <p-chip label="{{ user?.roleId === 2 ? 'Supervisore' : 'Operatore' }}" icon="fa-light fa-shield-check" />
      </div>

      <!-- Password fields — full width row, only shown in edit mode -->
      <div class="col-span-1 md:col-span-2" *ngIf="editMode">
        <p-divider></p-divider>
        <p class="text-sm text-gray-500 mb-3">Lascia vuoto per non modificare la password</p>
        <app-password-fields [group]="profileForm" />
      </div>

    </form>
  </p-card>

  <kc-loader [loading]="loading"></kc-loader>
</div>
